import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from './../config/config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../config/config.service";
export class BonogesService {
    constructor(httpClient, config) {
        this.httpClient = httpClient;
        this.config = config;
        this.headers = new HttpHeaders({
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
        });
    }
    getEventosGes(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/ObtenerEventosGes`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getBeneficiarios(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/GesBeneficiariosActivos`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getCentroMedicos(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/ObtenerCentrosMedicosGes`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    getCanastaGes(folio) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/ObtenerCanastaGes?eventoGes=${folio}`;
            try {
                return yield this.httpClient.get(url, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    valorizarBono(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/ValorizacionGes`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
    grabarBonoGes(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const config = yield this.config.getConfig();
            const url = `${config['endpoint']}/BonoGes/GrabarBonoGes`;
            try {
                return yield this.httpClient.post(url, data, { headers: this.headers }).toPromise();
            }
            catch (error) {
                return { status: false, code: 804, message: 'Error al ejecutar la petición.' };
            }
        });
    }
}
BonogesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BonogesService_Factory() { return new BonogesService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: BonogesService, providedIn: "root" });
